import urlcat from 'urlcat';

import { SearchParamKnownKeys } from 'src/hooks/useUrlSearchParams';

import { getSafeReturnToOrNull } from 'src/urls/sanitizeReturnTo';

/**
 * Login Flow Url
 */
const getLoginUrl = (options?: { returnTo?: string | null }): string => {
  const { returnTo } = options || {};
  return urlcat(window.location.origin, '/login', {
    [SearchParamKnownKeys.RETURN_TO]: getSafeReturnToOrNull(returnTo),
  });
};

export default getLoginUrl;
